import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ICellRendererAngularComp } from "@bfx/ag-grid-angular";
import { NativeDesktopSupport } from "src/app/bfx-native-desktop/native-desktop-support";
import { GammaAmountValue } from "../model/GammaAmountValue";
import { ICellRendererParams } from "ag-grid-community";

/**
 * Renderer component for Amount column for Gamma rungs.
 * For all active rungs, this will show an equiv tooltip icon that renders the equiv amount.
 * For MID_PENDING rungs, this will hide the amount.
 *
 * Currently the orderAmtUsdInvalid will always be set to false in parent column value setter.
 */
@Component({
  selector: "gamma-amount",
  templateUrl: "./html/GammaAmountRenderer.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GammaAmountRenderer implements ICellRendererAngularComp {
  public orderAmt: string;
  /** SHould tooltip be hidden */
  public showEquiv: boolean;
  public tooltip: string;

  private isGammaMid: boolean;

  private previous: { orderAmt: string; showEquiv: boolean; tooltip: string; isGammaMid: boolean };

  constructor(public cd: ChangeDetectorRef) {
    this.previous = {
      orderAmt: this.orderAmt,
      showEquiv: this.showEquiv,
      tooltip: this.tooltip,
      isGammaMid: this.isGammaMid,
    };
  }

  // called on init
  agInit(params: ICellRendererParams): void {
    this.doVal(params);
  }

  doVal(params: ICellRendererParams): boolean {
    this.previous.orderAmt = this.orderAmt;
    this.previous.showEquiv = this.showEquiv;
    this.previous.tooltip = this.tooltip;
    this.previous.isGammaMid = this.isGammaMid;

    this.isGammaMid = params?.data?.orderState == CubiqTS.OrderState.GAMMA_MID_PENDING;

    // process value set by colunm valueGetter from
    if (this.isGammaMid || !params.value) {
      this.orderAmt = "";
      this.showEquiv = false;
      this.tooltip = "";
    } else {
      const value: GammaAmountValue = params.value;
      this.orderAmt = value.orderAmt;
      this.showEquiv = !value.orderAmtUsdInvalid;
      this.tooltip = this.showEquiv ? value.orderAmtUsd : "";
    }

    return (
      this.orderAmt !== this.previous.orderAmt ||
      this.showEquiv !== this.previous.showEquiv ||
      this.tooltip !== this.previous.tooltip ||
      this.isGammaMid !== this.previous.isGammaMid
    );
  }

  // called when the cell is refreshed
  refresh(params: ICellRendererParams): boolean {
    if (this.doVal(params)) {
      this.cd.markForCheck();
    }

    return true;
  }

  public get desktop(): boolean {
    return NativeDesktopSupport.isNativeDesktopContainer();
  }
}
